import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { AppInterlayerReport, InterlayerReportService, InterlayerReportType } from 'app/services/interlayer-report.service';

@Component({
  selector: 'app-interlayer-report-tabs',
  templateUrl: './interlayer-report-tabs.component.html',
  styleUrls: ['./interlayer-report-tabs.component.css']
})
export class InterlayerReportTabsComponent implements OnInit, OnDestroy {


	reportList: AppInterlayerReport[]
	selectedReport: AppInterlayerReport;

	selectedReportType: InterlayerReportType;

	private reportSub: Subscription;
	private reportListSub: Subscription;
	constructor(
		private reportService: InterlayerReportService
	) { }

	onSelectReport(report) {
		if (this.selectedReport !== report) {
			this.selectedReport = report;
			this.reportService.selectedReportBS.next(this.selectedReport);
		}
	}
	ngOnInit() {
		this.reportSub = this.reportService.selectedReportBS.subscribe(data => {
			if (!data) {
				this.selectedReport = null;
			} else if (!this.selectedReport || this.selectedReport.label !== data.label) {
				this.selectedReport = this.reportList.find(r => r.label === data.label);
			}
		});
		this.reportListSub = this.reportService.reportListBS.subscribe(data => {
			if (!data) {
				return;
			}
			this.reportList = data.list;
			this.selectedReportType = data.reportType;

			if (this.selectedReport) {
				const selected = data.list.find(i => i.type === this.selectedReport.type && i.refLayerId === this.selectedReport.refLayerId && i.subjectLayerId === this.selectedReport.subjectLayerId);
				if (selected) {
					this.selectedReport = selected; // no need to trigger change
				} else {
					this.onSelectReport(this.reportList[0]);
				}
			} else {
				this.onSelectReport(this.reportList[0]);
			}
		})
	}
	ngOnDestroy(): void {
		this.reportSub.unsubscribe();
		this.reportListSub.unsubscribe();
	}

}
